import { axiosClient } from "../axios";

const baseUrl = "/api/admin/async-migration-jobs";

export function getAll() {
  return axiosClient.get(baseUrl);
}
